module.exports = __webpack_public_path__ + "static/media/temperatureForecast.86fcce20.png";